import { render, staticRenderFns } from "./InformationService.vue?vue&type=template&id=311ced68&scoped=true&lang=html&"
import script from "./InformationService.vue?vue&type=script&lang=js&"
export * from "./InformationService.vue?vue&type=script&lang=js&"
import style0 from "./InformationService.vue?vue&type=style&index=0&id=311ced68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ced68",
  null
  
)

export default component.exports